import { render } from "./homeNews.vue?vue&type=template&id=fbde2af4&scoped=true"
import script from "./homeNews.vue?vue&type=script&lang=js"
export * from "./homeNews.vue?vue&type=script&lang=js"

import "./homeNews.vue?vue&type=style&index=0&id=fbde2af4&scoped=true&lang=css"

import exportComponent from "E:\\edu-ui\\LyEducationAdmin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fbde2af4"]])

export default __exports__